/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */

/**
 * Javascript stuff for the single manifestation
 */

define('dng-manifestation',["jquery", "footable"], function($) {
    $(document).ready(function() {
        //Items info tooltip
        $tooltip = $('.circ .items').not('.pagetype-ManifestationPage .items');
        if ($tooltip.length) $tooltip.tooltip();
    });
    //Items modal event
    $('body').on('refreshed', '.items-modal', function() {
        $(this).find(".footable").footable();
    });
});
